/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CapturedSigningDetailsViewModel } from './CapturedSigningDetailsViewModel';
import {
    CapturedSigningDetailsViewModelFromJSON,
    CapturedSigningDetailsViewModelFromJSONTyped,
    CapturedSigningDetailsViewModelToJSON,
} from './CapturedSigningDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfCapturedSigningDetailsViewModel
 */
export interface ResultOfCapturedSigningDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {CapturedSigningDetailsViewModel}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    data?: CapturedSigningDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfCapturedSigningDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfCapturedSigningDetailsViewModel interface.
 */
export function instanceOfResultOfCapturedSigningDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfCapturedSigningDetailsViewModelFromJSON(json: any): ResultOfCapturedSigningDetailsViewModel {
    return ResultOfCapturedSigningDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfCapturedSigningDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCapturedSigningDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : CapturedSigningDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfCapturedSigningDetailsViewModelToJSON(value?: ResultOfCapturedSigningDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': CapturedSigningDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

